"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_1e8ymkqpaw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Favorite.tsx";
  var hash = "15b3d37b900412fbb9eecff6f75feb230c3d0d1c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Favorite.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "15b3d37b900412fbb9eecff6f75feb230c3d0d1c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1e8ymkqpaw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1e8ymkqpaw();
var Icon = (cov_1e8ymkqpaw().s[0]++, {
  name: 'favorite',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M11.9904 21.5596C11.7763 21.5596 11.5612 21.5211 11.3452 21.4442C11.1291 21.3672 10.9391 21.2467 10.775 21.0826L9.33848 19.7769C7.56539 18.1602 5.98238 16.5721 4.58943 15.0125C3.19648 13.4528 2.5 11.782 2.5 9.99998C2.5 8.58076 2.97852 7.39263 3.93558 6.43558C4.89263 5.47853 6.08076 5 7.49998 5C8.30638 5 9.10285 5.1859 9.8894 5.5577C10.6759 5.9295 11.3795 6.53335 12 7.36925C12.6205 6.53335 13.324 5.9295 14.1105 5.5577C14.8971 5.1859 15.6936 5 16.5 5C17.9192 5 19.1073 5.47853 20.0644 6.43558C21.0214 7.39263 21.5 8.58076 21.5 9.99998C21.5 11.8012 20.7916 13.4907 19.375 15.0682C17.9583 16.6458 16.3788 18.2205 14.6365 19.7923L13.2154 21.0826C13.0513 21.2467 12.8596 21.3672 12.6404 21.4442C12.4211 21.5211 12.2045 21.5596 11.9904 21.5596ZM11.2808 8.88845C10.7397 8.06408 10.1702 7.45992 9.5721 7.07595C8.97402 6.69197 8.28331 6.49998 7.49998 6.49998C6.49998 6.49998 5.66664 6.83331 4.99998 7.49998C4.33331 8.16664 3.99998 8.99998 3.99998 9.99998C3.99998 10.8025 4.25863 11.6416 4.77593 12.5173C5.29323 13.3929 5.94257 14.2634 6.72398 15.1288C7.50539 15.9942 8.35187 16.8397 9.2634 17.6653C10.1749 18.491 11.0198 19.2583 11.798 19.9673C11.8557 20.0186 11.923 20.0442 12 20.0442C12.0769 20.0442 12.1442 20.0186 12.2019 19.9673C12.9801 19.2583 13.825 18.491 14.7366 17.6653C15.6481 16.8397 16.4946 15.9942 17.276 15.1288C18.0574 14.2634 18.7067 13.3929 19.224 12.5173C19.7413 11.6416 20 10.8025 20 9.99998C20 8.99998 19.6666 8.16664 19 7.49998C18.3333 6.83331 17.5 6.49998 16.5 6.49998C15.7166 6.49998 15.0259 6.69197 14.4279 7.07595C13.8298 7.45992 13.2602 8.06408 12.7192 8.88845C12.6346 9.01665 12.5282 9.11281 12.4 9.17693C12.2718 9.24103 12.1384 9.27308 12 9.27308C11.8615 9.27308 11.7282 9.24103 11.6 9.17693C11.4718 9.11281 11.3654 9.01665 11.2808 8.88845Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;